import { render, staticRenderFns } from "./OfficeSettingsEditor.vue?vue&type=template&id=6d6d1c2e&scoped=true"
import script from "./OfficeSettingsEditor.vue?vue&type=script&lang=js"
export * from "./OfficeSettingsEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d6d1c2e",
  null
  
)

export default component.exports